import { useState } from 'react';
import { ENDPOINT_NAMES } from '../api/types';
import JournalTable from '../components/JournalTable';
import { Field, Input, PageHeader, Section, Select } from '../components/ui';

export default function Journal() {
  const [guid, setGuid] = useState('');
  const [endpoint, setEndpoint] = useState('');
  const [status, setStatus] = useState('');

  return (
    <div className="space-y-5">
      <PageHeader title="Journal des appels" />

      <Section title="Filtres">
        <div className="flex flex-wrap items-end gap-3">
          <Field label="Guid">
            <Input aria-label="Guid" value={guid} onChange={(e) => setGuid(e.target.value)} className="w-80" />
          </Field>
          <Field label="Endpoint">
            <Select aria-label="Endpoint" value={endpoint} onChange={(e) => setEndpoint(e.target.value)}>
              <option value="">Tous</option>
              {ENDPOINT_NAMES.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </Select>
          </Field>
          <Field label="Statut" hint="Préfixe : 2, 4, 401…">
            <Input aria-label="Statut" value={status} onChange={(e) => setStatus(e.target.value)} className="w-24" />
          </Field>
        </div>
      </Section>

      <Section title="Appels (rafraîchi toutes les 2 s)">
        <JournalTable filters={{ guid: guid || undefined, endpoint: endpoint || undefined, status: status || undefined }} />
      </Section>
    </div>
  );
}
